import React from 'react';
import { CustomTdWrapper } from 'app/components/wrappers';
import styled from 'styled-components';
type Props = {
  className?: string;
  value?: any;
  toolTipValue?: any;
  onClick?: (e) => void;
};
const CommonCell = ({ className, value, onClick, toolTipValue }: Props) => {
  const displayValue = value ?? '-';
  return (
    <Styledtd className={className ?? 'common-grid-cell'}>
      {value ? (
        <CustomTextWrapper
          className={className === 'booked-list-cell' ? 'booked-list-cell' : ''}
        >
          {/* <PassToolTip className="checking-cell"> */}
          <CustomTdWrapper
            title={`${toolTipValue ? toolTipValue : value}`}
            onClick={onClick}
            className="cell-data-wrapper"
            style={{ cursor: 'pointer' }}
          >
            {value}
          </CustomTdWrapper>
          {/* </PassToolTip> */}
        </CustomTextWrapper>
      ) : (
        <CustomTdWrapper onClick={onClick} className="cell-data-wrapper">
          {displayValue}
        </CustomTdWrapper>
      )}
    </Styledtd>
  );
};
export default CommonCell;
const CustomTextWrapper = styled.div`
  &.booked-list-cell {
    height: 100%;
    margin-top: 30px !important;
  }
`;
const Styledtd = styled.td`
  &.booked-list-cell {
    &:nth-child(1) {
      padding: 13px 0px 13px 24px !important;
    }
    &:nth-last-child(1) {
      padding: 13px 32px 13px 0px !important;
    }
  }
  &.converted-lc {
    .cell-data-wrapper {
      cursor: unset !important;
      font-size: 12px;
      color: ${p => p.theme.convertedTableFontColor};
    }
  }
`;
